export type TemplateLabelMap = Record<string, string>;
export type TemplateOptionLabels = Record<string, Record<string, string>>;

export interface TemplateDisplayData {
  fieldLabels: TemplateLabelMap;
  optionLabels: TemplateOptionLabels;
}

type TemplateStepShape = {
  stepId?: string;
  id?: string;
  key?: string;
  title?: string;
  name?: string;
} | undefined;

export const getTemplateStepId = (step: unknown): string => {
  const value = step as TemplateStepShape;
  return String(
    value?.stepId ||
      value?.id ||
      value?.key ||
      String(value?.title || "step")
        .toLowerCase()
        .replace(/\s+/g, "_"),
  );
};

type TemplateOptionShape = {
  value?: unknown;
  key?: unknown;
  id?: unknown;
} | undefined;

export const getOptionValue = (option: unknown): string => {
  if (typeof option === "string") return option;
  const opt = option as TemplateOptionShape;
  return String(opt?.value ?? opt?.key ?? opt?.id ?? "");
};

type TemplateOptionLabelShape = {
  label?: unknown;
  title?: unknown;
  text?: unknown;
  name?: unknown;
  value?: unknown;
  key?: unknown;
} | undefined;

export const getOptionLabel = (option: unknown): string => {
  if (typeof option === "string") return option;
  const opt = option as TemplateOptionLabelShape;
  return String(
    opt?.label ??
      opt?.title ??
      opt?.text ??
      opt?.name ??
      opt?.value ??
      opt?.key ??
      "",
  );
};

export const addOptionLabel = (
  labels: TemplateOptionLabels,
  fieldPath: string,
  value: string,
  label: string,
): void => {
  if (!value || !label) return;
  if (!labels[fieldPath]) labels[fieldPath] = {};
  labels[fieldPath][value] = label;
  labels[fieldPath][value.toLowerCase()] = label;
  labels[fieldPath][value.toUpperCase()] = label;
};
